import { render, staticRenderFns } from "./appletsIndex.vue?vue&type=template&id=c6ebf4a0&scoped=true"
import script from "./appletsIndex.vue?vue&type=script&lang=js"
export * from "./appletsIndex.vue?vue&type=script&lang=js"
import style0 from "./appletsIndex.vue?vue&type=style&index=0&id=c6ebf4a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ebf4a0",
  null
  
)

export default component.exports